export default __webpack_public_path__ + "roboto-v27-latin-regular.9b78ea3bc4f00e508f01331aa0733db8.woff";